// extracted by mini-css-extract-plugin
export default {"tabs":"Profile_tabs__Me85u","bio":"Profile_bio__pgzpK","panel":"Profile_panel__lzXTI","editProfile":"Profile_editProfile__st1vf"};